import React, { useState, useEffect, useRef } from 'react';
import { Icon } from '@fluentui/react/lib/Icon';
import { createPortal } from "react-dom";

import { useAppInsights } from '../../context/TelemetryContext';

import './Dropdown.css';

function Dropdown({ className, data, setValue, value, enableDropdown, renderFrom,
	newDropDownBox = '',
	newDropDownContainer='',
	newWrapHeader='',pageType = undefined 
 }) {	
	const { track } = useAppInsights();
	const [visible, setVisible] = useState(false);
  const dropdownContainerRef = useRef(null);
  const dropdownRef = useRef(null);
  const [menuPosition, setMenuPosition] = useState({
    top: 0,
    left: 0,
    width: 0,
  });

  const handleDropdown = (item) => {
    setValue(item);
    setVisible(false);
    track(1, 9, className, item.name);
  };

  useEffect(() => {
    const targetElement = document.querySelector("._allComlumns");
    const handleScroll = () => {
      if(renderFrom === "crowdSourcing"){
        setVisible(false);
      }
    };

    targetElement?.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      targetElement?.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (visible && dropdownRef.current) {
      const rect = dropdownRef.current.getBoundingClientRect();
      setMenuPosition({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
      });
    }

    const handleDropDownEscape = (e) => {
      if (e.key === "Escape" && enableDropdown) {
        setVisible(false);
      }
    };

    window.addEventListener("keydown", handleDropDownEscape);

    return () => {
      window.removeEventListener("keydown", handleDropDownEscape);
    };
  }, [visible]);

  useEffect(() => {
    const handleFocusOut = (event) => {
      if (
        dropdownContainerRef.current &&
        !dropdownContainerRef.current.contains(event.relatedTarget)
      ) {
        setVisible(false);
      }
    };
    dropdownContainerRef.current?.addEventListener("focusout", handleFocusOut);
    return () => {
      dropdownContainerRef.current?.removeEventListener(
        "focusout",
        handleFocusOut
      );
    };
  }, []);

  if (renderFrom === "crowdSourcing") {
    return (
      <>
        <div
          ref={dropdownRef}
          className={`position-relative ${className}`}
          onClick={() => enableDropdown && setVisible(!visible)}
        >
          <div
            className={`_crowdsourcingDropdown d-flex justify-content-between align-items-center ${
              enableDropdown ? "bg-white" : "bg-light disabled"
            }`}
            style={{ cursor: enableDropdown ? "pointer" : "not-allowed" }}
          >
            <span className="text-truncate">{value?.name || "Select"}</span>
            <Icon
              iconName="ChevronDown"
              style={{
                fontWeight: pageType === "Activity" ? "bolder" : "",
                fontSize: pageType === "Activity" ? "12px" : "",
              }}
            />
          </div>
        </div>
        {visible &&
          createPortal(
            <div
              className="dropdown-menu show"
              style={{
                position: "absolute",
                top: menuPosition.top,
                left: menuPosition.left,
                width: menuPosition.width,
                zIndex: 99999,
                backgroundColor: "white",
                borderRadius: 5,
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                display: "block",
              }}
            >
              {data?.map((item) => (
                <div
                  key={item.name}
                  onClick={() => handleDropdown(item)}
                  className="dropdown-item"
                  style={{ cursor: "pointer" }}
                >
                  {item.name}
                </div>
              ))}
            </div>,
            document.body
          )}
      </>
    );
  }
	return (
		<div
			id={className}
			title={
				enableDropdown
					? value?.name
					: className === 'complexityFilter'
						? 'Complexity Not Applicable'
						: className === 'complexityDisabled'
							? 'You can not change the complexity'
							: className === 'extractMethodologyComplexityDropdown' &&
								!enableDropdown
								? 'Complexity not applicable'
								: 'Role Not Applicable'
			}
		>
			<div
				className={`dropDowncontainer ${newDropDownContainer} ${className} ${enableDropdown ? '' : 'disableDropdown' 
					}`}
				ref={dropdownContainerRef}
			>
			<div
			id="complexityBoxId"
			className={`dropDownBox ${newDropDownBox}`}
			tabIndex={0}
			onKeyPress={(e) => {
				if (e.which === 13 && enableDropdown) {
				setVisible(!visible);
				}
			}}
			onClick={() => setVisible(!visible)}
			aria-expanded={visible ? 'true' : 'false'}
			role="link"
			aria-label={`Complexity dropdown ${visible ? 'expanded' : 'collapsed'} ${value?.name} selected`}
			>
			<span className={`wrapHeader ${newWrapHeader}`} aria-hidden="true">{value?.name}</span>
			<Icon iconName="ChevronDown" style={{ fontWeight: pageType ==='Activity' ? 'Bolder':'' ,fontSize: pageType==='Activity' ? '12px':''}} aria-hidden="true" />
			</div>


				<div style={{ display: 'block' }}>
					<div
						className="dropDownList"
						style={{ display: visible ? 'block' : '' }}
					>
						<ul role="listbox" aria-labelledby="size">
							{data?.map((item) => {
								if (item.type === 'header') {
									return (
										<li
											className="dropdownHeader"
											title={item.name + ' Header'}
											key={item.name}
											role="listitem"
										>
											<span>{item.name}</span>
										</li>
									);
								}
								return (
									<li
										className={value?.name===item?.name?'activeComplexityRow':''}
										tabIndex={0}
										onKeyPress={(e) => {
											if (e.which === 13) {
												handleDropdown(item);
											}
										}}
										onClick={() => handleDropdown(item)}
										title={item.name}
										key={item.name}
										role="option"
									>
										<span>{item.name}</span>
									</li>
								);
							})}
						</ul>
					</div>
				</div>
			</div>
		</div>
);
}

export default Dropdown;
